import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import hintApi from "../api/hint";
import { sendError } from "../errors";

export const fetchCurrentHint = createAsyncThunk(
  "hints/fetchCurrentHintStatus",
  async (page = null) => {
    try {
      return await hintApi.fetch(page);
    } catch (err) {
      sendError(err);
    }
  }
);

export const hintsSlice = createSlice({
  name: "hints",
  initialState: {
    hintsLoading: false,
    hint: null,
    currentHintState: null,
    currentHintDisabled: false,
  },
  reducers: {
    setCurrentHint: (state, { payload }) => {
      state.hint = payload;
      state.currentHintState = null;
    },
    setCurrentHintDisabled: (state, { payload }) => {
      state.currentHintDisabled = payload;
    },
    setCurrentHintState: (state, { payload }) => {
      state.currentHintState = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCurrentHint.pending, (state) => {
      state.hintsLoading = true;
    });
    builder.addCase(fetchCurrentHint.fulfilled, (state, action) => {
      state.hint = action.payload;
      state.hintsLoading = false;
    });
    builder.addCase(fetchCurrentHint.rejected, (state) => {
      // TODO: Log error
      state.hintsLoading = false;
    });
  },
});
export const { setCurrentHint, setCurrentHintDisabled, setCurrentHintState } =
  hintsSlice.actions;

export default hintsSlice.reducer;
